import { Translations } from 'react-querybuilder';

// Define operator translations
// @ts-ignore
export const operatorLabels: any = {
    exact: { name: "exact", value: "exact", label: "Равно" },
    iexact: { name: "iexact", value: "iexact", label: "Равно (без учета регистра)" },
    contains: { name: "contains", value: "contains", label: "Содержит" },
    icontains: { name: "icontains", value: "icontains", label: "Содержит (без учета регистра)" },
    in: { name: "in", value: "in", label: "В списке" },
    gt: { name: "gt", value: "gt", label: "Больше" },
    gte: { name: "gte", value: "gte", label: "Больше или равно" },
    lt: { name: "lt", value: "lt", label: "Меньше" },
    lte: { name: "lte", value: "lte", label: "Меньше или равно" },
    startswith: { name: "startswith", value: "startswith", label: "Начинается с" },
    istartswith: { name: "istartswith", value: "istartswith", label: "Начинается с (без учета регистра)" },
    endswith: { name: "endswith", value: "endswith", label: "Заканчивается на" },
    iendswith: { name: "iendswith", value: "iendswith", label: "Заканчивается на (без учета регистра)" },
    range: { name: "range", value: "range", label: "В диапазоне" },
    year: { name: "year", value: "year", label: "Год" },
    month: { name: "month", value: "month", label: "Месяц" },
    day: { name: "day", value: "day", label: "День" },
    week_day: { name: "week_day", value: "week_day", label: "День недели (начиная с воскресенья)" },
    iso_week_day: { name: "iso_week_day", value: "iso_week_day", label: "День недели (ISO, начиная с понедельника)" },
    week: { name: "week", value: "week", label: "Номер недели" },
    iso_year: { name: "iso_year", value: "iso_year", label: "Год (ISO-8601)" },
    quarter: { name: "quarter", value: "quarter", label: "Квартал" },
    time: { name: "time", value: "time", label: "Время" },
    hour: { name: "hour", value: "hour", label: "Час" },
    minute: { name: "minute", value: "minute", label: "Минута" },
    second: { name: "second", value: "second", label: "Секунда" },
    date: { name: "date", value: "date", label: "Дата" },
    isnull: { name: "isnull", value: "isnull", label: "Пустое значение" },
    regex: { name: "regex", value: "regex", label: "Совпадает с регулярным выражением" },
    iregex: { name: "iregex", value: "iregex", label: "Совпадает с регулярным выражением (без учета регистра)" },
    contained_by: { name: "contained_by", value: "contained_by", label: "Содержится в" },
    len: { name: "len", value: "len", label: "Длина" },
    overlap: { name: "overlap", value: "overlap", label: "Пересечение" },
    has_key: { name: "has_key", value: "has_key", label: "Содержит ключ" },
    has_keys: { name: "has_keys", value: "has_keys", label: "Содержит все указанные ключи" },
    has_any_keys: { name: "has_any_keys", value: "has_any_keys", label: "Содержит хотя бы один из ключей" },
    ne: { name: "ne", value: "ne", label: "Не равен" },
    contains_all: { name: "contains_all", value: "contains_all", label: "Содержит все" },
};

export const translations: Partial<Translations> = {
    fields: {
        title: "Поля"
    },
    operators: operatorLabels,
    value: {
        title: "Значение"
    },
    removeRule: {
        label: "Удалить правило",
        title: ""
    },
    removeGroup: {
        label: "Удалить группу",
        title: ""
    },
    cloneRuleGroup: {
        title: "Клонировать группу"
    },
    addRule: {
        label: "Добавить правило",
        title: ""
    },
    addGroup: {
        label: "Добавить группу",
        title: ""
    },
    notToggle: {
        label: "Не",
        title: "Не"
    },
    cloneRule: {
        label: "Дублировать",
        title: ""
    },
    valueSourceSelector: {
        title: "Источник значения"
    },
    shiftActionUp: { title: "Переместить вверх" },
    shiftActionDown: { title: "Переместить вниз" },
};
